import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../api/pocketbase'; // Assure-toi d'utiliser une instance unique

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Restaurer proprement la session avec authRefresh
  useEffect(() => {
    const restoreSession = async () => {
      try {
        await pb.collection('users').authRefresh(); // Important pour restaurer la session côté PocketBase
        const user = pb.authStore.model;
        setCurrentUser(user || null);
        setUserRole(user?.role || null);
        console.log('✅ Session restaurée avec authRefresh :', user);
        console.log("📦 pb.authStore.token :", pb.authStore.token);
        console.log("🔒 pb.authStore.isValid :", pb.authStore.isValid);
      } catch (error) {
        console.warn("⚠️ Aucune session valide à restaurer :", error);
        setCurrentUser(null);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    restoreSession();
  }, []);

  // Fonction de connexion
  const login = async (username, role) => {
    try {
      // On suppose que l'auth a déjà été faite ailleurs (LoginForm par exemple)
      const user = pb.authStore.model;

      if (!user) {
        throw new Error("Utilisateur non valide dans pb.authStore");
      }

      const effectiveRole = user.role || role || 'unknown';
      setCurrentUser(user);
      setUserRole(effectiveRole);

      console.log('🔐 Utilisateur connecté :', {
        email: user.email,
        role: effectiveRole
      });

      return true;
    } catch (error) {
      console.error('❌ Erreur lors de la connexion dans AuthProvider:', error);
      return false;
    }
  };

  // Fonction de déconnexion
  const logout = () => {
    try {
      pb.authStore.clear(); // Supprime la session
      setCurrentUser(null);
      setUserRole(null);
      console.log('👋 Déconnexion réussie');
    } catch (error) {
      console.error('❌ Échec de la déconnexion :', error);
    }
  };

  const hasRole = (requiredRole) => {
    return userRole === requiredRole;
  };

  const value = {
    currentUser,
    userRole,
    login,
    logout,
    hasRole
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
